import { motion } from "framer-motion";

export const FadeIn = ({ children, delay = 0, className = "", y = 32 }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
        className={className}
    >
        {children}
    </motion.div>
);

export const Chapter = ({ number, label }) => (
    <FadeIn>
        <div
            data-testid={`chapter-${number}`}
            className="mb-10 flex items-center gap-4 md:mb-14"
        >
            <span className="font-mono text-xs tracking-[0.3em] text-ember md:text-sm">
                {number}
            </span>
            <span className="h-px w-16 bg-ember/60 md:w-24" />
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-400 md:text-sm">
                {label}
            </span>
        </div>
    </FadeIn>
);
